export default __webpack_public_path__ + "static/media/netbit3.99158571.png";